import { BaseProductData } from './products'
import { GTM_MAIN_EVENT_NAME, GtmEvent, GtmEventTypes } from '.'

export interface AddToCartData extends BaseProductData {}

export interface RemoveFromCartData extends BaseProductData {}

export interface AddToCartEvent extends GtmEvent {
  detail: {
    eventType: GtmEventTypes.AddToCart
    data: AddToCartData
  }
}

export interface RemoveFromCartEvent extends GtmEvent {
  detail: {
    eventType: GtmEventTypes.RemoveFromCart
    data: RemoveFromCartData
  }
}

export const isAddToCartEvent = (evt: GtmEvent): evt is AddToCartEvent =>
  evt.detail.eventType === GtmEventTypes.AddToCart

export const isRemoveFromCartEvent = (
  evt: GtmEvent
): evt is RemoveFromCartEvent =>
  evt.detail.eventType === GtmEventTypes.RemoveFromCart

export const createAddToCartEvent = (data: AddToCartData): AddToCartEvent =>
  new CustomEvent(GTM_MAIN_EVENT_NAME, {
    bubbles: true,
    detail: { data, eventType: GtmEventTypes.AddToCart },
  })

export const createRemoveFromCartEvent = (
  data: RemoveFromCartData
): RemoveFromCartEvent =>
  new CustomEvent(GTM_MAIN_EVENT_NAME, {
    bubbles: true,
    detail: { data, eventType: GtmEventTypes.RemoveFromCart },
  })
